import { render, staticRenderFns } from "./RedesignTeamDetailsPrise.vue?vue&type=template&id=68462ed6&scoped=true"
import script from "./RedesignTeamDetailsPrise.vue?vue&type=script&lang=js"
export * from "./RedesignTeamDetailsPrise.vue?vue&type=script&lang=js"
import style0 from "./RedesignTeamDetailsPrise.vue?vue&type=style&index=0&id=68462ed6&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignTeamDetailsPrise.vue?vue&type=style&index=1&id=68462ed6&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68462ed6",
  null
  
)

export default component.exports